import React from "react";
import * as S from "./styles";
import LoadingElevaty from "../../components/LoadingElevaty";
import { ClientInfo } from "./ClientInfo";
import { InstallmentCalculator } from "./InstallmentCalculator";
import { InstallmentOptionsTable } from "./InstallmentOptionsTable";
import Footer from "./Footer";
import { InstallmentInformation } from "./InstallmentInformation";
import { InvoiceInstallmentSimulatorFlowProps } from "./types";
import { useInvoiceInstallmentSimulatorFlow } from "./useInvoiceInstallmentSimulatorFlow";

export function InvoiceInstallmentSimulatorFlow({
  onClose,
  devedorTotal = false,
  currentInvoice,
  invoices,
}: InvoiceInstallmentSimulatorFlowProps) {
  const {
    clientInfos,
    goBack,
    goNext,
    isLoadingActivate,
    hasPermissionToChangeTax,
    installmentOptions,
    isLoadingParameters,
    isLoadingSimulate,
    onSelectInstallmentOption,
    onSimulateClickHandler,
    parameters,
    selectedInstallmentOption,
    step,
  } = useInvoiceInstallmentSimulatorFlow({ devedorTotal, onClose });

  return (
    <>
      {isLoadingParameters ? (
        <S.LoadingWrapper>
          <LoadingElevaty />
        </S.LoadingWrapper>
      ) : (
        <>
          {step === 0 && (
            <>
              <ClientInfo
                creditCardNumber={clientInfos.creditCardNumber}
                currentInvoiceValue={clientInfos.currentInvoiceValue}
                debitBalance={clientInfos.debitBalance}
                name={clientInfos.name}
              />
              <InstallmentCalculator
                parameters={parameters}
                installmentOptions={installmentOptions}
                selectedInstallmentOption={selectedInstallmentOption}
                hasPermissionToChangeTax={hasPermissionToChangeTax}
                isLoading={isLoadingSimulate}
                onSimulate={onSimulateClickHandler}
              />

              <InstallmentOptionsTable
                installmentOptions={installmentOptions}
                onSelectOption={onSelectInstallmentOption}
                selectedRow={selectedInstallmentOption}
              />
            </>
          )}
          {step === 1 && (
            <InstallmentInformation
              currentInvoice={currentInvoice}
              invoices={invoices}
              selectedInstallmentOption={selectedInstallmentOption ?? {}}
            />
          )}
          <Footer
            goBack={goBack}
            goNext={goNext}
            hasSelectedInstallmentOption={
              !!selectedInstallmentOption?.quantidadeParcelas
            }
            isLoading={isLoadingActivate}
            onClose={onClose}
            step={step}
          />
        </>
      )}
    </>
  );
}
